import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { httpOptionsDefault } from "../constants";

export class ViaCepController {
 


 
    constructor(public _http: HttpClient) {

      
    } 
    
    
    getAddress(cep: string) {

        cep = cep.replace(/\D/g, "");
    
        let address = `https://viacep.com.br/ws/${cep}/json/`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
  
    }

}